<h1 mat-dialog-title>Please Confirm</h1>
<div mat-dialog-content>
  <p [innerHTML]="message"></p>
</div>
<div mat-dialog-actions align="center">
  <button class="btn btn-default" [mat-dialog-close] cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary" [mat-dialog-close]="true">Accept</button>
</div>
